import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TextField from '../TextField';

import FormStylesOptions from '../../../../constants/FormStylesOptions';

const StyledWrapper = styled.div`
  display: flex;
  flex: 1;
`;

const StyledTableWrapper = styled.div`
  display: flex;
  margin-right: 8px;
  padding: 4px;
  border: ${(props) => props.border};
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius}px;
`;

const StyledField = styled.div`
`;

const StyledTable = styled.table`
  border-spacing: 0px;

  font-size:${(props) => props.fontSize};
  font-style: ${(props) => props.fontStyle};
  font-weight: ${(props) => props.fontWeight};
  text-align: ${(props) => props.textAlign};
  text-transform: ${(props) => props.textTransform};
  text-decoration: ${(props) => props.textDecoration};
  color: ${(props) => props.fontColor};
  background-color: ${(props) => props.backgroundColor};

`;

const StyledTableHeader = styled.th`
  text-align: left;
  font-size: 12px;
  color: ${(props) => props.fontColor};
  padding: 2px;
`;

const StyledTableBody = styled.tbody`
`;

const StyledTableRow = styled.tr`
`;

const StyledTableData = styled.td`
  padding: 2px;
`;

const ChartFieldForm = ({
  id,
  fieldId,
  yTitle,
  yMin,
  yMax,
  xTitle,
  xMin,
  xMax,

  //Field style
  fontSize,
  fontColor,
  fontStyle,
  fontWeight,
  textAlign,
  textTransform,
  textDecoration,
  textOverflow,
  borderColor,
  borderRadius,
  borderWidth,
  backgroundColor,
  padding,

  //Action handlers
  onChange,
  identifier,
}) => {

  const titleStyles = {
    titleFontStyle: fontStyle,
    titleFontWeight: 'bold',
    titleTextTransform: textTransform,
  };

  const fieldStyles = {
    fontSize,
    fontColor,
    fontStyle,
    fontWeight,
    textAlign,
    textTransform,
    textDecoration,
    textOverflow,
    borderColor,
    borderRadius,
    borderWidth,
    backgroundColor,
    padding,
  };

  /**
   * We join width and color to a single border style because chrome displays
   * the border as a two tone color if you use border-color and border-width
   * indvidually.
   */
  const border = `${borderWidth}px solid ${borderColor}`;

  return (
    <StyledWrapper {...{ border, borderRadius, backgroundColor, borderWidth }}>
      <StyledTableWrapper {...{ border, borderRadius, backgroundColor, borderWidth }}>
        <StyledTable {...{ border, borderRadius, backgroundColor, borderWidth }}>
          <StyledTableBody>
            <StyledTableRow>
              <StyledTableHeader

                style={{ width: '100px', maxWidth: '100px' }}
              >
                Vertical (Y)
              </StyledTableHeader>
              <StyledTableHeader
                style={{ width: '60px', maxWidth: '60px' }}
              >
                Min
              </StyledTableHeader>
              <StyledTableHeader
                style={{ width: '60px', maxWidth: '60px' }}
              >
                Max
              </StyledTableHeader>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableData style={{ width: '100px', maxWidth: '100px' }}>
                <StyledField>
                  <TextField
                    {...fieldStyles}
                    {...titleStyles}
                    id={`${id}-y-label`}
                    fieldId={fieldId}
                    value={yTitle}
                    type="text"
                    identifier={identifier}
                    textOverflow={FormStylesOptions.textOverflowEllipsis}
                    onChange={(fieldId, fieldIdentifier, fieldPositionId, value) => { onChange({ yTitle: value }); }}
                  />
                </StyledField>
              </StyledTableData>
              <StyledTableData style={{ width: '60px', maxWidth: '60px' }}>
                <TextField
                  {...fieldStyles}
                  id={`${id}-y-min`}
                  fieldId={fieldId}
                  value={yMin}
                  identifier={identifier}
                  onChange={(fieldId, fieldIdentifier, fieldPositionId, value) => onChange({ yMin: value ? parseFloat(value, 10) : 0 })}
                  type="number"
                  textOverflow={FormStylesOptions.textOverflowEllipsis}
                />
              </StyledTableData>
              <StyledTableData style={{ width: '60px', maxWidth: '60px' }}>
                <TextField
                  {...fieldStyles}
                  id={`${id}-y-max`}
                  fieldId={fieldId}
                  value={yMax}
                  identifier={identifier}
                  onChange={(fieldId, fieldIdentifier, fieldPositionId, value) => onChange({ yMax: value ? parseFloat(value, 10) : 0 })}
                  type="number"
                  textOverflow={FormStylesOptions.textOverflowEllipsis}
                />
              </StyledTableData>
            </StyledTableRow>
          </StyledTableBody>
        </StyledTable>
      </StyledTableWrapper>
      <StyledTableWrapper {...{ border, borderRadius, backgroundColor, borderWidth }}>
        <StyledTable {...{ border, borderRadius, backgroundColor, borderWidth }}>
          <StyledTableBody>
            <StyledTableRow>
              <StyledTableHeader
                style={{ width: '100px', maxWidth: '100px' }}
              >
                Horizontal (X)
              </StyledTableHeader>
              <StyledTableHeader
                style={{ width: '60px', maxWidth: '60px' }}
              >
                Min
              </StyledTableHeader>
              <StyledTableHeader
                style={{ width: '60px', maxWidth: '60px' }}
              >
                Max
              </StyledTableHeader>
            </StyledTableRow>
            <StyledTableRow>
              <StyledTableData style={{ width: '100px', maxWidth: '100px' }}>
                <StyledField>
                  <TextField
                    {...fieldStyles}
                    {...titleStyles}
                    id={`${id}-x-label`}
                    fieldId={fieldId}
                    type="text"
                    identifer={identifier}
                    value={xTitle}
                    textOverflow={FormStylesOptions.textOverflowEllipsis}
                    onChange={(fieldId, fieldIdentifier, fieldPositionId, value) => onChange({ xTitle: value })}
                  />
                </StyledField>
              </StyledTableData>
              <StyledTableData style={{ width: '60px', maxWidth: '60px' }}>
                <TextField
                  {...fieldStyles}
                  id={`${id}-x-min`}
                  fieldId={fieldId}
                  type="number"
                  value={xMin}
                  identifer={identifier}
                  textOverflow={FormStylesOptions.textOverflowEllipsis}
                  onChange={(fieldId, fieldIdentifier, fieldPositionId, value) => onChange({ xMin: value ? parseFloat(value, 10) : 0 })}
                />
              </StyledTableData>
              <StyledTableData style={{ width: '60px', maxWidth: '60px' }}>
                <TextField
                  {...fieldStyles}
                  id={`${id}-x-max`}
                  fieldId={fieldId}
                  value={xMax}
                  identifier={identifier}
                  type="number"
                  textOverflow={FormStylesOptions.textOverflowEllipsis}
                  onChange={(fieldId, fieldIdentifier, fieldPositionId, value) => onChange({ xMax: value ? parseFloat(value, 10) : 0 })}
                />
              </StyledTableData>
            </StyledTableRow>
          </StyledTableBody>
        </StyledTable>
      </StyledTableWrapper>
    </StyledWrapper>
  );

};

ChartFieldForm.propTypes = {
  id: PropTypes.string,
  fieldId: PropTypes.string,
  yTitle: PropTypes.string,
  yMin: PropTypes.number,
  yMax: PropTypes.number,
  xTitle: PropTypes.string,
  xMin: PropTypes.number,
  xMax: PropTypes.number,

  //Field style
  fontSize: PropTypes.number,
  fontColor: PropTypes.string,
  fontStyle: PropTypes.string,
  fontWeight: PropTypes.string,
  textAlign: PropTypes.string,
  textTransform: PropTypes.string,
  textDecoration: PropTypes.string,
  textOverflow: PropTypes.string,
  borderColor: PropTypes.string,
  borderRadius: PropTypes.number,
  borderWidth: PropTypes.number,
  backgroundColor: PropTypes.string,
  padding: PropTypes.number,

  //Action handlers
  onChange: PropTypes.func,
};

export default React.memo(ChartFieldForm);
